import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow, FlexColumn } from "@similarweb/ui-components";

import { TOPICS_CONTAINER_HEIGHT } from "app/pages/activation/components/Topics/Modal/constants";

export const StyledHeader = styled(FlexRow)`
    box-sizing: border-box;
    align-items: center;
    padding: 20px 24px;
    gap: 8px;
    justify-content: space-between;
`;

StyledHeader.displayName = "Header";

export const StyledTitle = styled.h5`
    ${setFontVariant("h5_2", colorsPalettes.carbon[500])};
    line-height: 1;
    margin: 0;
`;

StyledTitle.displayName = "Title";

export const StyledBody = styled(FlexColumn)`
    box-sizing: border-box;
    padding: 16px 24px 24px 24px;
    gap: 16px;
`;

StyledBody.displayName = "Body";

export const StyledSubTitleContainer = styled(FlexRow)`
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
`;

StyledSubTitleContainer.displayName = "SubTitleContainer";

export const StyledBodyText = styled.h6`
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    margin: 0;
`;

StyledBodyText.displayName = "BodyText";

export const StyledCreatedTopicsCounter = styled.span`
    ${setFontVariant("caption", colorsPalettes.carbon[300])};
`;

StyledCreatedTopicsCounter.displayName = "CreatedTopicsCounter";

export const StyledFooter = styled(FlexRow)`
    box-sizing: border-box;
    justify-content: space-between;
    gap: 4px;
    padding: 8px 16px 16px;
`;

StyledFooter.displayName = "Footer";

export const StyledKeyWordsContainer = styled(FlexColumn)`
    gap: 16px;
    overflow: auto;
    max-height: ${TOPICS_CONTAINER_HEIGHT}px;
`;

StyledKeyWordsContainer.displayName = "KeyWordsContainer";
